import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { Save01, Trash01 } from 'untitledui-js-base';

interface ChangeAccidentStateDialogProps extends DialogProps {
  onAccept: (note?: string) => void;
  isLoading?: boolean;
  isRejected?: boolean;
  onRemove?: () => void;
  isDealerStatementRejected?: boolean;
}

export const ChangeAccidentStateDialog = ({
  open,
  isLoading,
  onClose,
  onAccept,
  isRejected,
  onRemove,
  isDealerStatementRejected,
  ...props
}: ChangeAccidentStateDialogProps) => {
  const methods = useForm<{ note?: string }>({
    defaultValues: {
      note: ''
    }
  });

  const {
    handleSubmit,
    formState: { errors },
    control,
    reset
  } = methods;

  const handleSubmitForm = (data: { note?: string }) => {
    onAccept(data.note);
    reset();
  };

  const handleCloseForm = () => {
    onClose?.({}, 'backdropClick');
    reset();
  };

  return (
    <Dialog open={Boolean(open)} onClose={handleCloseForm} maxWidth="md" {...props}>
      <form onSubmit={handleSubmit(handleSubmitForm)}>
        <DialogTitle id="alert-dialog-title">Úprava / smazání záznamu</DialogTitle>
        <DialogContent>
          <Stack gap={2}>
            <Typography>
              Změnit status nehody na <strong>{isRejected ? 'čekající' : 'nevyšlou'}</strong>?
            </Typography>
            <Controller
              control={control}
              name="note"
              render={({ field: { onChange, value } }) => (
                <TextField
                  value={value}
                  onChange={onChange}
                  label="Důvod"
                  color="secondary"
                  fullWidth
                  error={Boolean(errors.note)}
                  helperText={errors.note?.message}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{
            paddingX: 4,
            paddingY: 2,
            flexDirection: { xs: 'column-reverse', md: 'row' },
            gap: 2
          }}
        >
          <Button onClick={handleCloseForm}>Zavřít</Button>
          {isDealerStatementRejected && (
            <Button
              onClick={onRemove}
              startIcon={<Trash01 />}
              color="error"
              variant="contained"
              size="large"
              loading={isLoading}
            >
              Smazat záznam
            </Button>
          )}
          <Button
            type="submit"
            variant="contained"
            color="success"
            loading={isLoading}
            size="large"
            startIcon={<Save01 />}
          >
            Změnit stav
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
